var TextureSoftware = /** @class */ (function () {
    function TextureSoftware(width, height) {
        this._mipLevels = [];
        this._width = width;
        this._height = height;
    }
    Object.defineProperty(TextureSoftware.prototype, "textureType", {
        get: function () {
            return TextureSoftware.textureType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextureSoftware.prototype, "width", {
        get: function () {
            return this._width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextureSoftware.prototype, "height", {
        get: function () {
            return this._height;
        },
        enumerable: true,
        configurable: true
    });
    TextureSoftware.prototype.dispose = function () {
        this._mipLevels = null;
    };
    TextureSoftware.prototype.isTexture = function (textureClass) {
        return this.textureType == textureClass.textureType;
    };
    TextureSoftware.prototype.uploadFromArray = function (array, miplevel) {
        if (miplevel === void 0) { miplevel = 0; }
        this._mipLevels[miplevel] = ((array instanceof Array) ? new Uint8ClampedArray(array) : new Uint8ClampedArray(array.buffer));
    };
    TextureSoftware.prototype.uploadFromURL = function (urlRequest, miplevel) {
        if (miplevel === void 0) { miplevel = 0; }
    };
    TextureSoftware.prototype.getData = function (miplevel) {
        return this._mipLevels[miplevel];
    };
    TextureSoftware.prototype.getMipLevelsCount = function () {
        return this._mipLevels.length;
    };
    TextureSoftware.prototype.generateMipmaps = function () {
        //TODO
    };
    TextureSoftware.textureType = "texture2d";
    return TextureSoftware;
}());
export { TextureSoftware };
